<app-b-notification></app-b-notification>

<ng-template #customLoadingTemplate>
    <div class="custom-class-loader">
        <div class="spinner-container">
            <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
        </div>
    </div>
</ng-template>

<div *ngIf="!isLogoutRoute && !isErrorRoute">

    <ngx-loading *ngIf="showSpinner" [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }"
        [template]="customLoadingTemplate">
    </ngx-loading>
    <div *ngIf="redirectingToLogin" class="redirecting-to-login">
        <p>Redirecting to login…</p>
        <p class="fallback-hint">If you are not redirected, <button type="button" class="btn btn-link" (click)="authPromptService.promptLogin()">click here to log in</button>.</p>
    </div>
    <div *ngIf="showMicroUi && loginUserInfo && !redirectingToLogin">
        <app-microfrontend-inbox [folderName]="folderName" [accessType]="accessType" [entityTypeParam]="entityTypeParam"
            [entityDetails]="entityDetails" [productFamilyParam]="productFamilyParam"
            [dealStatusParam]="dealStatusParam" [inquiryIdParam]="inquiryIdParam"></app-microfrontend-inbox>
    </div>
    <div *ngIf="notShowMicroUi && !loginUserInfo && !redirectingToLogin">
        <app-core></app-core>
    </div>
</div>


<!-- Router outlet for logout route -->
<router-outlet></router-outlet>

<p-toast key="qmaToast"></p-toast>
